const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: [],
  },
  add: {
    isLoading: false,
    error: '',
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
